import { isEdelvives } from 'app/utils/utils';

export type TenantChatConfig = {
  className: string;
  excludeRoutes: string[];
  excludeRoutesWithFloatingButton: RegExp[];
  contextExtras: Record<string, string>;
  shellOverrides: { isDevMode?: boolean };
  shouldTryMsalToken: boolean;
};

const TANGERINE_CONFIG: TenantChatConfig = {
  className: 'tangerine-ai-chatbot',
  excludeRoutes: [
    '/login',
    '/logout',
    '/signup',
    '/forgot-password',
    '/reset-password',
    '/error',
    '/credits',
    '/terms-of-use',
    '/privacy-policy',
    '/teacher-tools/',
  ],
  excludeRoutesWithFloatingButton: [/^\/activities\/sessions\/[^/]+\/summary$/, /^\/results-assesment-individual\//, /^\/practice-launch\//],
  contextExtras: {},
  shellOverrides: {},
  shouldTryMsalToken: false,
};

const EDELVIVES_CONFIG: TenantChatConfig = {
  className: 'edelvives-ai-chatbot',
  excludeRoutes: [
    '/auth',
    '/logout',
    '/auth/login',
    '/auth/signup',
    '/recover-password',
    '/reset-password',
    '/error',
    '/privacy',
    '/terms',
    '/config',
    '/tab-auth-start',
    '/tab-auth-end',
    '/teacher-tools/',
  ],
  excludeRoutesWithFloatingButton: [/^\/activities\/sessions\/[^/]+\/summary$/, /^\/practice-launch\//],
  contextExtras: { tenant: 'edelvives' },
  // Debug tools stay hidden on Edelvives even on dev hosts.
  shellOverrides: { isDevMode: false },
  shouldTryMsalToken: true,
};

export function getTenantChatConfig(): TenantChatConfig {
  return isEdelvives() ? EDELVIVES_CONFIG : TANGERINE_CONFIG;
}
